import { render } from "./HowToPlayView.vue?vue&type=template&id=4f0a4d98&scoped=true"
import script from "./HowToPlayView.vue?vue&type=script&lang=js"
export * from "./HowToPlayView.vue?vue&type=script&lang=js"

import "./HowToPlayView.vue?vue&type=style&index=0&id=4f0a4d98&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0a4d98"]])

export default __exports__